import {injectable, decorate} from 'inversify';
import {withDebugInfo} from '../../utils/withDebugInfo/withDebugInfo';
import {IMediaPlatformApi} from './IMediaPlatformApi';
import {CheckStatusResult, FileStatus} from './types';
import {createHttpClient, HttpResponse} from '@wix/http-client';

export class MediaPlatformApi implements IMediaPlatformApi {
  async getFileStatus(fileId: string): Promise<CheckStatusResult> {
    let resp: HttpResponse;

    try {
      resp = await createHttpClient().get<FileInfoResponse>(
        `https://files.wix.com/v3/files/${encodeURIComponent(fileId)}/info`,
      );
    } catch (error) {
      if (error?.response?.data?.error_code === -7710) {
        return withDebugInfo({status: FileStatus.Missing}, {response: error.response.data});
      }
      throw error;
    }
    const opStatus = resp.data.op_status;
    const status = this.getStatus(opStatus);

    return withDebugInfo({status}, {originalStatus: opStatus, response: resp.data});
  }

  private getStatus(opStatus: string): FileStatus {
    switch (opStatus) {
      case 'READY':
        return FileStatus.Ready;
      case 'INPROGRESS':
      case 'IN_PROGRESS':
        return FileStatus.InProgress;
      case 'FAILED':
        return FileStatus.Failed;
      default:
        return FileStatus.Unknown;
    }
  }
}

decorate(injectable(), MediaPlatformApi);

interface FileInfoResponse {
  op_status: string;
}
